import { format, getYear as dateFnsGetYear, formatDuration } from 'date-fns';

export const getNextMonthDate = (d = new Date()) => {
    const currentMonth = d.getMonth();
    const currentYear = d.getFullYear();
    const isLastYearMonth = currentMonth == 11;

    return isLastYearMonth ? new Date(currentYear + 1, 0, 1) : new Date(currentYear, currentMonth + 1, 1);
}

export const duration = seconds => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds - hours * 60 * 60) / 60);

    return formatDuration({
        hours,
        minutes
    });
};

export const durationShort = seconds => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds - hours * 60 * 60) / 60);

    const parts = [];
    if (hours) {
        parts.push(`${hours}h`);
    }
    if (minutes) {
        parts.push(`${minutes}m`);
    }

    return parts.join(' ');
};

export const isSameDay = (first, second) => {
    return first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate();
};

export const isPastDate = (date) => {
    const now = new Date();
    now.setHours(0,0,0,0);

    return date < now;
};

export const getMonthName = (d = new Date()) => format(d, 'LLLL');
export const getYear = (d = new Date()) => dateFnsGetYear(d);

